"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageLevelMessageType = void 0;
var PageLevelMessageType;
(function (PageLevelMessageType) {
    PageLevelMessageType["SUCCESS"] = "SUCCESS";
    PageLevelMessageType["WARNING"] = "WARNING";
    PageLevelMessageType["ERROR"] = "ERROR";
    PageLevelMessageType["INFO"] = "INFO";
})(PageLevelMessageType = exports.PageLevelMessageType || (exports.PageLevelMessageType = {}));
//# sourceMappingURL=PageLevelMessageProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/PageLevelMessage/PageLevelMessageProps.js
// module id = 654
// module chunks = 8